import React, { FC, ReactText, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ISelectOption } from 'components/forms/Selects'
import { SingleSelect } from 'transfix-ui/components/SingleSelect'
import { IFilterInputProps } from 'apps/fleet-planner/pages/loads/FilterFacilityLocation'
import { IDriver, ILoadFilters } from 'apps/fleet-planner/types'
import { selectDrivers } from 'apps/fleet-planner/utils/selectors'
import { UserIcon } from 'transfix-icons'

const mapDrivers = (d: IDriver[] = []): ISelectOption<string>[] =>
  d.map(({ id: value = '', name: label = '' }) => ({ value, label }))

export interface IFilterDriverProps
  extends IFilterInputProps<Partial<Pick<ILoadFilters, 'driverId'>>> {}

export const FilterDriver: FC<IFilterDriverProps> = ({
  onChange: onChangeProp,
  value: valueProp,
}) => {
  const drivers = useSelector(selectDrivers)
  const options = useMemo(() => mapDrivers(drivers), [drivers])

  const selectHandler = useCallback(
    (change?: ISelectOption<ReactText> | undefined) => {
      const { value } = change || {}
      onChangeProp({ driverId: value as string })
    },
    [onChangeProp]
  )

  const { driverId = '' } = valueProp || {}

  return (
    <SingleSelect
      id='loads-driver-filter'
      dataTest='loads-driver-filter'
      icon={<UserIcon size='large' />}
      label='Driver'
      options={options}
      onSelect={selectHandler}
      selected={driverId}
      emptyStateLabel='No saved drivers'
    />
  )
}
